<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content-f w800">
    <div class="modal-header">
      <b>{{ $t('ll.credit_history_title') }}</b>
      <button type="button" class="close" @click.prevent="showModal = false" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Načítání...</span>
        </div>
      </div>

      <div v-else-if="hasEshopOrders">
        <div class="mb-3">
          <strong>{{ $t('ll.total_credit') }}:</strong> {{ totalCredit }} {{ $t('ll.lessons') }}
        </div>

        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>{{ $t('ll.date') }}</th>
              <th>{{ $t('ll.type') }}</th>
              <th>{{ $t('ll.lector') }}</th>
              <th>{{ $t('ll.order') }}</th>
              <th>{{ $t('ll.lesson_duration') }}</th>
              <th>{{ $t('ll.amount') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="lesson in history" :key="lesson.lesson_id">
              <tr v-for="transfer in lesson.credit_transfers" :key="transfer.id">
                <td>{{ formatDate(transfer.created_at) }}</td>
                <td>
                  <span :class="getCreditTypeClass(transfer.kind)">
                    {{ getCreditTypeLabel(transfer.kind) }}
                  </span>
                </td>
                <td>{{ lesson.lector_name || '-' }}</td>
                <td>{{ transfer.order_number || '-' }}</td>
                <td>{{ lesson.minutes }} min</td>
                <td :class="transfer.amount > 0 ? 'text-success' : 'text-danger'">
                  {{ transfer.amount > 0 ? '+' : '' }}{{ transfer.amount }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div v-else class="alert alert-info">
        {{ $t('ll.no_eshop_orders_message') }}
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import axios from "axios";

export default {
  name: "credit-history-modal",
  components: { VueFinalModal },
  props: {
    studentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      loading: false,
      totalCredit: 0,
      history: [],
      hasEshopOrders: true
    };
  },
  methods: {
    async open() {
      this.showModal = true;
      await this.loadCreditHistory();
    },
    close() {
      this.showModal = false;
    },
    async loadCreditHistory() {
      this.loading = true;
      try {
        const response = await axios.get('/ll/home/credit_history');
        this.totalCredit = response.data.total_credit;
        this.history = response.data.history;
        
        // Zkontrolovat, jestli má student nějaké kredity z e-shopu
        const hasEshopCredits = this.history.some(lesson => 
          lesson.credit_transfers.some(t => t.kind === 'initial_credit' || t.kind === 'eshop_order')
        );
        
        this.hasEshopOrders = hasEshopCredits || this.history.length > 0;
      } catch (error) {
        console.error('Error loading credit history:', error);
        this.hasEshopOrders = false;
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getCreditTypeLabel(kind) {
      const labels = {
        initial_credit: this.$t('ll.purchase'),
        update_vyuka: this.$t('ll.adjustment'),
        lesson_realized: this.$t('ll.lesson_used'),
        correction: this.$t('ll.correction'),
        eshop_order: this.$t('ll.eshop_order'),
        eshop_refund: this.$t('ll.eshop_refund')
      };
      return labels[kind] || kind;
    },
    getCreditTypeClass(kind) {
      const classes = {
        initial_credit: 'badge bg-success',
        update_vyuka: 'badge bg-info',
        lesson_realized: 'badge bg-warning',
        correction: 'badge bg-secondary',
        eshop_order: 'badge bg-success',
        eshop_refund: 'badge bg-danger'
      };
      return classes[kind] || 'badge bg-light';
    }
  }
};
</script>

<style scoped>
.w800 {
  max-width: 800px;
  width: 90%;
}

.table {
  font-size: 14px;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
